module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [(_vm.isCountryDK) ? _c('div', [_c('h1', {
    staticClass: "primary-color"
  }, [_vm._v("Kontakt os, hvis du ønsker at få fuld adgang til Docendo")]), _vm._v(" "), _c('ul', {
    staticClass: "docendo-contact-options"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('li', [_c('h4', [_vm._v("Eller skriv en chatbesked")]), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn--primary",
    on: {
      "click": _vm.openCrispChat
    }
  }, [_vm._v("Skriv en chatbesked")])])]), _vm._v(" "), _c('Pricing')], 1) : _vm._e(), _vm._v(" "), (!_vm.isCountryDK) ? _c('div', [_c('h1', [_vm._v(_vm._s(_vm.$t('vue.buy.buy_access_for_school_users')))]), _vm._v(" "), _c('div', {
    staticClass: "col-1-2 marg-20-bottom"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue.buy.a_user_is')))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.countryIsDkOrNo) ? _c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.choose_the_right_price')))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.countryIsDkOrNo) ? _c('div', {
    staticClass: "marg-20-bottom flex"
  }, [_c('div', {
    staticClass: "col-1-2"
  }, [_c('div', {
    staticClass: "pointer border rounded pad-20 center",
    class: {
      'active': _vm.isSelectedModel(1),
      'notActive': _vm.isSelectedModel(2)
    },
    on: {
      "click": function($event) {
        return _vm.selectModel(1)
      }
    }
  }, [_c('h3', {
    staticClass: "font-large marg-10-bottom"
  }, [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$t('vue.buy.per_user'))))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "marg-10-bottom"
  }, [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$t('vue.buy.price'))) + " " + _vm._s(_vm.$t('vue.buy.per_user')))]), _vm._v(" "), _c('p', {
    staticClass: "text-blue bold blue-price"
  }, [_vm._v(_vm._s(_vm.userPrice) + " " + _vm._s(_vm.currency))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.per_user')) + " / " + _vm._s(_vm.$t('vue.buy.month')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "marg-10-bottom"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('vue.buy.only_pay_per')) + "\n            ")]), _vm._v(" "), _c('button', {
    staticClass: "cta-button"
  }, [_vm._v("\n              " + _vm._s(_vm.$t('repitition.choose')) + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-1-2"
  }, [_c('div', {
    staticClass: "pointer pos-relative border rounded pad-20 center",
    class: {
      'active': _vm.isSelectedModel(2),
      'notActive': _vm.isSelectedModel(1)
    },
    on: {
      "click": function($event) {
        return _vm.selectModel(2)
      }
    }
  }, [_c('h3', {
    staticClass: "font-large marg-10-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue.buy.unlimited')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h3', {
    staticClass: "marg-10-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue.buy.total_student_number')))]), _vm._v(" "), _c('p', {
    staticClass: "text-blue bold blue-price"
  }, [_vm._v(_vm._s(_vm.pupilsPrice) + " " + _vm._s(_vm.currency))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.per_student')) + " / " + _vm._s(_vm.$t('vue.buy.month')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "marg-10-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue.buy.pay_for_unlimited_users_and_get')))]), _vm._v(" "), _c('button', {
    staticClass: "cta-button"
  }, [_vm._v(_vm._s(_vm.$t('repitition.choose')))])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedModel !== null) ? _c('div', [_c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.subscription_info')))]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.isSelectedModel(1)) ? _c('div', [_c('div', {
    staticClass: "form-group large-margin form-group__input"
  }, [_c('label', [_vm._v("\n              " + _vm._s(_vm.$t('vue.buy.write_number_of_users')) + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.lazy",
      value: (_vm.users),
      expression: "users",
      modifiers: {
        "number": true,
        "lazy": true
      }
    }],
    staticClass: "type_number",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.users)
    },
    on: {
      "change": function($event) {
        _vm.users = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (_vm.isSelectedModel(2)) ? _c('div', [_c('div', {
    staticClass: "form-group large-margin form-group__input"
  }, [_c('label', [_vm._v("\n              " + _vm._s(_vm.$t('vue.buy.write_number_of_students')) + "\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number.lazy",
      value: (_vm.pupils),
      expression: "pupils",
      modifiers: {
        "number": true,
        "lazy": true
      }
    }],
    staticClass: "type_number",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.pupils)
    },
    on: {
      "change": function($event) {
        _vm.pupils = _vm._n($event.target.value)
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('vue.buy.billed_monthly_or_yearly')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group large-margin form-group__radiobuttons"
  }, [_c('br'), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.interval),
      expression: "interval",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "monthly",
      "value": "1"
    },
    domProps: {
      "checked": _vm._q(_vm.interval, _vm._n("1"))
    },
    on: {
      "change": function($event) {
        _vm.interval = _vm._n("1")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "monthly"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue.buy.per_month')))])]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.interval),
      expression: "interval",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "radio",
      "id": "yearly",
      "value": "2"
    },
    domProps: {
      "checked": _vm._q(_vm.interval, _vm._n("2"))
    },
    on: {
      "change": function($event) {
        _vm.interval = _vm._n("2")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "yearly"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue.buy.per_year')) + " "), _c('span', {
    staticClass: "discount"
  }, [_vm._v(_vm._s(_vm.$t('vue.buy.save_2')) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "billing-bill large-margin"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.your_invoice')))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('p', [_vm._v("1 " + _vm._s(_vm.$t('vue.buy.institution')))]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.$t('vue.buy.per_year') : _vm.$t('vue.buy.per_month')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.monthlyInstitutionPrice * 12 : _vm.monthlyInstitutionPrice * 1) + " " + _vm._s(_vm.currency) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    class: {
      'invalid-price': _vm.selectedModel !== 1
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.users === '' ? '0' : _vm.users) + " "), _c('span', [_vm._v(_vm._s(_vm.$t('repitition.users')))])]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.$t('vue.buy.per_year') : _vm.$t('vue.buy.per_month')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.userAmount * 12 : _vm.userAmount) + " " + _vm._s(_vm.currency) + "\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    class: {
      'invalid-price': _vm.selectedModel !== 2
    }
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.$t('vue.buy.unlimited'))), _c('span', [_vm._v(" " + _vm._s(_vm.$t('repitition.users')))])]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.$t('vue.buy.per_year') : _vm.$t('vue.buy.per_month')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("0 " + _vm._s(_vm.currency))])]), _vm._v(" "), _c('div', {
    staticClass: "flex",
    class: {
      'invalid-price': _vm.selectedModel !== 2
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.pupils === "" || _vm.pupils < 0 ? '0' : _vm.pupils) + " "), _c('span', [_vm._v(_vm._s(_vm.$t('vue.buy.discount')))])]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.$t('vue.buy.per_year') : _vm.$t('vue.buy.per_month')) + "\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n              " + _vm._s(_vm.yearlyPayment ? _vm.pupilAmount * 12 : _vm.pupilAmount) + " " + _vm._s(_vm.currency) + "\n            ")])]), _vm._v(" "), (_vm.yearlyPayment) ? _c('div', {
    staticClass: "flex bg-discount"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.discount')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.per_year')))]), _vm._v(" "), _c('p', [_vm._v("-" + _vm._s(_vm.yearlySavings) + " " + _vm._s(_vm.currency))])]) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('vue.buy.total')))]), _vm._v(" "), _c('p', [(_vm.yearlyPayment) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue.buy.per_year')))]) : _c('span', [_vm._v(_vm._s(_vm.$t('vue.buy.per_month')))])]), _vm._v(" "), _c('p', {
    staticClass: "total-amount"
  }, [_vm._v(_vm._s(_vm.totalAmount) + " " + _vm._s(_vm.currency))])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.payment_info')))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group__input"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue.buy.school_name')) + " *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.schoolName),
      expression: "schoolName"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.schoolName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.schoolName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group__input"
  }, [_c('label', [_vm._v(_vm._s(_vm.$filters.capitalize(_vm.$t('vue.buy.your_name'))) + " *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group__input"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue.buy.your_email')) + " *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group__input"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('vue.buy.your_phonenumber')) + " *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "cta-button",
    attrs: {
      "disabled": !_vm.buyButtonEnabled
    },
    on: {
      "click": _vm.buyClick
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('vue.buy.buy')) + "\n        ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-1-2"
  }, [_c('div', {
    staticClass: "center"
  }, [_c('h2', [_vm._v(_vm._s(_vm.$t('vue.buy.questions')) + " ?")]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.$t('vue.buy.call_us_at')) + " +45 43 31 06 12")])])]), _vm._v(" "), _c('modal', {
    attrs: {
      "show": _vm.showModal,
      "close_on_click_away": true
    },
    on: {
      "close": _vm.closedModal
    }
  }, [_c('h1', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v(_vm._s(_vm.modalHeader))]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-vertical-center",
    staticStyle: {
      "flex-direction": "row",
      "justify-content": "center",
      "align-items": "center",
      "height": "100%"
    },
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.modalBody)
    }
  })]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  })])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('h4', [_vm._v("Ring til os på")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:43310612"
    }
  }, [_vm._v("43 31 06 12")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('h4', [_vm._v("Skriv en en email")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:kontakt@docendo.dk"
    }
  }, [_vm._v("kontakt@docendo.dk")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6dc8227f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Buy.vue
// module id = 1994
// module chunks = 1